<template>
	<Col :span="24">
		<VerticalLayout>
			<MasonryContainer>
				<MasonryItem headerKey="settings.about.licenseSubHeader">
					<LicenseForm :onUpdate="fetchSettings" />
				</MasonryItem>
				<MasonryItem headerKey="settings.about.versionsSubHeader">
					<VersionsDisplay :loading="isLoading" :status="statusData" />
				</MasonryItem>
				<MasonryItem headerKey="settings.about.envVarsSubHeader">
					<EnvVarsDisplay :loading="isLoading" :status="statusData" />
				</MasonryItem>
			</MasonryContainer>
		</VerticalLayout>
	</Col>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Col } from 'ant-design-vue';

import Api from '@/api/Api';

import VerticalLayout from '@/components/common/VerticalLayout';

import MasonryContainer from '@/components/masonry/MasonryContainer';
import MasonryItem from '@/components/masonry/MasonryItem';

import LicenseForm from '@/components/settings/LicenseForm';
import VersionsDisplay from '@/components/settings/VersionsDisplay';
import EnvVarsDisplay from '@/components/settings/EnvVarsDisplay';

export default {
	components: {
		Col,
		VerticalLayout,
		MasonryContainer,
		MasonryItem,
		LicenseForm,
		VersionsDisplay,
		EnvVarsDisplay,
	},
	setup() {
		const isLoading = ref(true);
		const statusData = ref({});
		const fetchSettings = () => {
			isLoading.value = true;
			Api.vrsSettingsGet(responseData => {
				statusData.value = responseData.statusData;
				isLoading.value = false;
			});
		};
		onMounted(fetchSettings);
		return {
			isLoading,
			statusData,
			fetchSettings,
		}
	},
}
</script>
